import { createFileRoute } from '@tanstack/react-router';

import { Layout } from './-components/Layout';
import { ReleaseNotesForm } from './-components/ReleaseNotesForm';

export const Route = createFileRoute('/_authenticated/releasenotes/new')({
    component: () => (
        <Layout>
            <ReleaseNotesForm />
        </Layout>
    ),
});
